<template>
  <div id="game-official-website"  class="pcIndex">
    <div class="content">
      <span>PC端官网暂未开放,请使用手机浏览官网。</span>
    </div>
  </div>
</template>
  <script>
export default {
  name: "index",
  data() {
    return {
      userInfo: [],
    };
  },
  components: {},
  created() {},

  mounted() {},

  destroyed() {},
  methods: {},
};
</script>
<style  scoped lang="scss">
.pcIndex{
  width: 100%;
}
.content{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 240px;
  span{
    font-size: 28px;
    color: #000;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/index.vue